export default __webpack_public_path__ + "static/media/cherry.52560170.png";